import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-comment",
  "use": "foquz-icon-comment-usage",
  "viewBox": "0 0 22 23",
  "content": "<symbol viewBox=\"0 0 22 23\" fill=\"none\" id=\"foquz-icon-comment\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.063 21.358v-4.247h2.499A2.44 2.44 0 0022 14.67V2.443A2.442 2.442 0 0019.562 0H2.438A2.44 2.44 0 000 2.443v12.226a2.442 2.442 0 002.438 2.442h7.917l5.761 4.7c.52.42.947.22.947-.453zM15 15.022v2.966l-3.753-2.966H2V2.02h18.031v13.002H15z\" fill=\"currentColor\" /><path d=\"M5 7.02h12v-2H5v2zm0 5h5v-2H5v2zm8 0h4v-2h-4v2z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol